export default __webpack_public_path__ + "media/kai.4f0b995d.png";